/**
 * PWA 설치/업데이트 이벤트를 백엔드로 전송한다.
 *
 * 비로그인 사용자도 호출 가능 (백엔드 SecurityConfig에서 permitAll).
 * 실패해도 사용자 경험에 영향이 없으므로 silent fail 한다.
 *
 * 영구지침: docs/develop/pwa/pwa-spec.md §3.5, §4.7
 */
import apiClient from '@/lib/api/client'

export type PwaInstallEventType =
  | 'BANNER_SHOWN'
  | 'BANNER_DISMISSED'
  | 'INSTALL_PROMPTED'
  | 'INSTALLED'
  | 'UPDATE_ACCEPTED'
  | 'UPDATE_DISMISSED'

export async function logPwaEvent(
  eventType: PwaInstallEventType,
  referrer?: string
): Promise<void> {
  try {
    await apiClient.post('/pwa/install-events', {
      eventType,
      referrer: referrer ?? (typeof window !== 'undefined' ? window.location.pathname : null),
    })
  } catch {
    // 실패해도 사용자 경험에 영향 없음
  }
}
